<template lang="pug">
    p(:class="{'mb': marginBottom, 'ml': marginLeft}", v-if="content")
      b {{ label }}
      span(v-if="textIcon !== ''")
        el-tooltip.item(
          effect='dark',
          :content='textIcon',
          :placement="toolTip"
        )
          font-awesome-icon.icon(icon="info-circle" size="1x")
      span.text(v-if="content") &nbsp {{content}}
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number]
    },
    marginBottom: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: Boolean,
      default: false
    },
    textIcon: {
      type: String,
      default: ''
    },
    toolTip: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.mb {
  margin-bottom: 2vh;
}

.ml {
  margin-left: 15px;
}

.text {
  color: $font-color;
}

p {
  margin: 0 0 10px !important;
  font-size: 14px;
  b {
    color: $font-dark-color;
    span{
      font-weight: normal !important;
    }
  }
}

.icon {
  margin-left: 2px;
  margin-right: 2px;
  color: #b2b6be;
}
</style>
